export default "__VITE_ASSET__sh0ETOtc__"